import { OrganizationService } from 'data/services';
import { OrganizationServiceInterface } from 'domain/services';
import { makeGetAllOrganizationsUser } from 'main/factories/usecases/organizations/remote-get-all-organizations-user-factory';

export const makeOrganizationService = (): OrganizationServiceInterface => {
  return new OrganizationService(makeGetAllOrganizationsUser());
};
